import { defineAction } from 'redux-define';

export default {
  // auth
  AUTH_LOGIN: defineAction('AUTH_LOGIN', ['REQUEST', 'SUCCESS', 'FAILURE']),
  AUTH_REGISTER: defineAction('AUTH_REGISTER', ['REQUEST', 'SUCCESS', 'FAILURE']),
  FORGET_PASSWORD: defineAction('FORGET_PASSWORD', ['REQUEST', 'SUCCESS', 'FAILURE']),
  RESET_PASSWORD: defineAction('RESET_PASSWORD', ['REQUEST', 'SUCCESS', 'FAILURE']),
  VERIFY_TOKEN: defineAction('VERIFY_TOKEN', ['REQUEST', 'SUCCESS', 'FAILURE']),
  AUTH_LOGOUT: defineAction('AUTH_LOGOUT', ['REQUEST', 'SUCCESS', 'FAILURE']),

  // projects
  GET_ALL_PROJECTS: defineAction('GET_ALL_PROJECTS', ['REQUEST', 'SUCCESS', 'FAILURE']),
  GET_PROJECT: defineAction('GET_PROJECT', ['REQUEST', 'SUCCESS', 'FAILURE']),
  SELECT_PROJECT: defineAction('SELECT_PROJECT', ['REQUEST', 'SUCCESS', 'FAILURE']),
  CREATE_PROJECT: defineAction('CREATE_PROJECT', ['REQUEST', 'SUCCESS', 'FAILURE']),
  UPDATE_PROJECT: defineAction('UPDATE_PROJECT', ['REQUEST', 'SUCCESS', 'FAILURE']),
  DELETE_PROJECT: defineAction('DELETE_PROJECT', ['REQUEST', 'SUCCESS', 'FAILURE']),

  // stakeholders
  GET_ALL_STAKEHOLDERS: defineAction('GET_ALL_STAKEHOLDERS', ['REQUEST', 'SUCCESS', 'FAILURE']),
  GET_STAKEHOLDER: defineAction('GET_STAKEHOLDER', ['REQUEST', 'SUCCESS', 'FAILURE']),
  CREATE_STAKEHOLDER: defineAction('CREATE_STAKEHOLDER', ['REQUEST', 'SUCCESS', 'FAILURE']),
  UPDATE_STAKEHOLDER: defineAction('UPDATE_STAKEHOLDER', ['REQUEST', 'SUCCESS', 'FAILURE']),
  DELETE_STAKEHOLDER: defineAction('DELETE_STAKEHOLDER', ['REQUEST', 'SUCCESS', 'FAILURE']),
  DELETE_STAKEHOLDERS: defineAction('DELETE_STAKEHOLDERS', ['REQUEST', 'SUCCESS', 'FAILURE']),

  // connections
  GET_ALL_CONNECTIONS: defineAction('GET_ALL_CONNECTIONS', ['REQUEST', 'SUCCESS', 'FAILURE']),
  GET_CONNECTION: defineAction('GET_CONNECTION', ['REQUEST', 'SUCCESS', 'FAILURE']),
  CREATE_CONNECTION: defineAction('CREATE_CONNECTION', ['REQUEST', 'SUCCESS', 'FAILURE']),
  UPDATE_CONNECTION: defineAction('UPDATE_CONNECTION', ['REQUEST', 'SUCCESS', 'FAILURE']),
  DELETE_CONNECTION: defineAction('DELETE_CONNECTION', ['REQUEST', 'SUCCESS', 'FAILURE']),
  DELETE_CONNECTIONS: defineAction('DELETE_CONNECTIONS', ['REQUEST', 'SUCCESS', 'FAILURE']),

  // connections
  GET_ALL_USERS: defineAction('GET_ALL_USERS', ['REQUEST', 'SUCCESS', 'FAILURE']),
  GET_USER: defineAction('GET_USER', ['REQUEST', 'SUCCESS', 'FAILURE']),
  UPDATE_USER: defineAction('UPDATE_USER', ['REQUEST', 'SUCCESS', 'FAILURE']),
  DELETE_USER: defineAction('DELETE_USER', ['REQUEST', 'SUCCESS', 'FAILURE']),
};
